<!-- search template -->

<div center title search-bar>
  <sh-icon
    icon="cancel"
    class="cancel-search-mobile"
    *ngIf="routeService.searchString$ | async"
    button
    (click)="cancelSearch()"
    aria-label="Close Search"
    tabindex="-1"
    size="xs"
  ></sh-icon>
  <!-- desktop version has different action and is always closable when open (has no back button) -->
  <sh-icon
    icon="cancel"
    class="cancel-search-desktop"
    *ngIf="routeService.searchString$ | async"
    button
    (click)="cancelSearch()"
    aria-label="Close Search"
    tabindex="-1"
    size="s"
  ></sh-icon>
  <sh-progress *ngIf="searching$ | async" size="s" indeterminate> </sh-progress>
  <form
    action="."
    onsubmit="return false"
    role="search"
    [attr.keyboard-in-use]="keyboardInUse ? true : null"
  >
    <input
      [disabled]="(searching$ | async) ? true : null"
      #searchInput
      id="searchInput"
      type="text"
      autocomplete="off"
      autocapitalize="none"
      [placeholder]="
        ((screenLayoutService.phone$ | async)
          ? 'search.callToActionShort'
          : 'search.callToAction'
        ) | translate
      "
      [value]="routeService.searchString$ | async"
      (input)="routeService.setSearchString($event.target.value)"
      (keyup.enter)="pressEnter($event)"
      (keyup.escape)="closeSearch()"
      (focus)="routeService.openSearch(false)"
      (click)="openSearch()"
      aria-controls="search-popover"
      [attr.aria-expanded]="(searchPageOpen$ | async) ? 'true' : 'false'"
      [attr.aria-activedescendant]="activeDescendant$ | async"
      aria-haspopup="listbox"
      role="combobox"
    />
  </form>
  <sh-icon
    id="main-search-icon"
    tabindex="-1"
    icon="search"
    aria-label="Search"
    size="xs"
    aria-hidden="true"
    (click)="triggerSearch()"
  ></sh-icon>
</div>
<!-- search page -->

<div
  #searchPopover
  class="search"
  id="search-popover"
  role="listbox"
  [attr.searching]="(searchPageOpen$ | async) ? true : null"
  (click)="closeSearch()"
  (keyup.enter)="closeSearch()"
  tabindex="-1"
>
  <sh-card raised (click)="$event.preventDefault(); $event.stopPropagation()">
    <div
      slot="header"
      style="display: flex; flex-direction: column; width: 100%"
    >
      <!-- #{{ focusedElement$ | async }}<br />
      active descendant: {{ activeDescendant$ | async }}<br /> -->
      <sh-tabs role="group" aria-label="Results Tabs">
        <sh-tab-item
          id="tab-results"
          data-index="0"
          tabindex="-1"
          keyboard-focusable
          label="Results"
          aria-label="Results"
          [attr.aria-checked]="tabActive(0) ? 'true' : 'false'"
          [active]="tabActive(0)"
          [disabled]="(hasResults$ | async) !== true"
          (click)="selectedTab$.next(0)"
          role="option"
        ></sh-tab-item>
        <sh-tab-item
          id="tab-history"
          data-index="1"
          tabindex="-1"
          keyboard-focusable
          [attr.aria-checked]="tabActive(1) ? 'true' : 'false'"
          label="History"
          aria-label="History"
          [active]="tabActive(1)"
          (click)="selectedTab$.next(1)"
          role="option"
        ></sh-tab-item>
        <sh-tab-item
          favs
          id="tab-favs"
          tabindex="-1"
          data-index="2"
          keyboard-focusable
          [attr.aria-checked]="tabActive(2) ? 'true' : 'false'"
          label="Favorites"
          aria-label="Favorites"
          [active]="tabActive(2)"
          (click)="selectedTab$.next(2)"
          role="option"
        ></sh-tab-item>
      </sh-tabs>

      <div
        class="modality-settings"
        *ngIf="
          (selectedTab$ | async) === 0 &&
          (modalitySettingsWereHiddenByUser$ | async) !== true &&
          ((showModalitySettings$ | async) ||
            (modalitySettingsWereShown$ | async))
        "
      >
        <sh-icon
          button
          size="s"
          icon="cancel"
          aria-label="Hide Settings"
          aria-hidden="true"
          (click)="modalitySettingsWereHiddenByUser$.next(true)"
        ></sh-icon>
        <app-component-settings
          [menuMode]="false"
          [modalitySelectorMode]="true"
        ></app-component-settings>
      </div>
    </div>
    <span
      role="option"
      aria-selected="false"
      close-option
      aria-label="Close Search"
    >
      <sh-icon
        button
        icon="cancel"
        size="s"
        color="secondary"
        aria-label="Close Search"
        (click)="closeSearch()"
      ></sh-icon>
    </span>

    <ng-container *ngIf="tabActive(0)">
      <!-- search results -->
      <sh-spinner
        *ngIf="searching$ | async"
        label="Searching SeSO.."
      ></sh-spinner>
      <ng-container *ngIf="(searching$ | async) !== true">
        <sh-text
          size="body-2"
          class="num-systems"
          color="secondary"
          *ngIf="searchResults$ | async"
          >{{ (items$ | async)?.length }} systems found</sh-text
        >

        <app-search-results-list
          [items$]="items$"
          [highlight]="searchString$ | async"
          (openSystem)="goToSystem($event)"
        ></app-search-results-list>
      </ng-container>
    </ng-container>
    <!-- recents + favs -->
    <app-search-results-list
      *ngIf="!tabActive(0)"
      [items$]="items$"
      [highlight]="searchString$ | async"
      (openSystem)="goToSystem($event)"
    ></app-search-results-list>
  </sh-card>
</div>
